import { createFileRoute, redirect } from "@tanstack/react-router";
import { number, object, optional } from "valibot";

export const Route = createFileRoute("/_auth/_app/eap-review/$purchaseId")({
  validateSearch: object({ stars: optional(number()) }),
  beforeLoad: async account => {
    throw redirect({
      to: "/eap",
      replace: true,
      search: {
        review: {
          purchaseId: "$purchaseId",
          stars: account.search.stars ?? undefined,
        },
      },
      mask: {
        to: "/eap",
      },
    });
  },
});
